import Cookies from 'js-cookie';
import { CountUp } from 'countup.js';
import 'sticksy';

const handler = ( $ ) => {

	// make Topics Sticky
	if( $('.sticky-topics').length ) {
		let sticksy = new Sticksy('.sticky-topics', {topSpacing: $('#header').outerHeight() + 60, listen: true});
		$('body').on('fp_ajax_pagination_loaded', function() {
			sticksy.hardRefresh();
		});
	}

	/**
	 * Animate stat numbers
	 */
	$('.page-template-page-tpl-community-conversations .stats-block .numbers').each( function() {
		let numbers = new CountUp( $(this)[0], $(this).data('to'), {
			separator: ''
		});
		if (!numbers.error) {
			numbers.start();
		}
	});

	/**
	 * Max title numbers counter
	 */
	$('#new-conversation-title').on( 'keyup paste', function() {

		const $input = $(this),
		inputText = $.trim( $input.val() ),
		textLen = inputText.length,
		$counter = $('#new-conversation-title-counter');

		$counter.html( `${textLen}/300` );

	});

	/**
	 * Submit a question
	 */
	$('#new-conversation-form').on( 'submit', function( e ) {
		e.preventDefault();

		let data = new FormData();

		const $form = $(this),
		$errors = $form.find('.error'),
		$file = $form.find('.answer-attachment-file'),
		fileVal = $file.val(),
		newPostTitle = $.trim( $('#new-conversation-title').val() ),
		newPostContent = $.trim( $form.find('#start-conversation-textarea').html() ),
		$fileError = $file.parent().find('.error');

		$errors.hide();

		let isError = false;

		if( newPostTitle == '' ) {
			$('#new-conversation-title').parent().find('.error').show();
			$('#new-conversation-title').focus();
			isError = true;
		}

		if( newPostContent == '' ) {
			$form.find('#start-conversation-textarea').parent().find('.error').show();
			tinymce.execCommand( 'mceFocus', false, 'start-conversation-textarea');
			isError = true;
		}

		if( isError ) {
			return false;
		}

		data.append( 'action', 'post_new_question');
		data.append( 'nonce', Cookies.get( 'wordpress_pen_ajax_nonce' ));
		data.append( 'title', newPostTitle );
		data.append( 'content', newPostContent );

		if( $file[0].files.length > 0 ) {

			const ext = fileVal.substr( ( fileVal.lastIndexOf('.') +1) ).toLowerCase();
			const sizeInKb = Math.floor( $file[0].files[0].size / 1024 );

			if( themeVars.question_answer_allowed_file_types.includes( ext ) == false ) {

				$fileError.html( 'This file type is not supported' );
				$fileError.show();

				return false;

			} else if ( sizeInKb > 2500 ) {

				$fileError.html('Please choose a file less than 2.5Mb');
				$fileError.show();

				return false;

			}

			data.append( 'attachment', $file[0].files[0] );

		}

		$.ajax({
			url: themeVars.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: data,
			enctype: 'multipart/form-data',
			processData: false,
			contentType: false
		}).done( function( answer ) {

			if( answer.success ) {
				window.location = answer.data.redirectURL;
			} else {
				alert( answer.data.message );
			}

		});

	});

};

export default ( ( $ ) => $( handler ) )( jQuery );
